controllers.controller('SignupController', [
    '$window', '$scope', '$state', '$ionicLoading', '$q', '$timeout', '$ionicModal', 'config', 'constants',
    'ErrorService', 'LocaleService', 'LoginService', 'API', 'Utils', 'LocalStorage', 'Storage', 'Validator',
    'Init', 'UserService', '$cookies', 'AccountService', 'CountryService', 'SocialAuthService',
    function ($window, $scope, $state, $ionicLoading, $q, $timeout, $ionicModal, config, Const,
              ErrorService, LocaleService, LoginService, API, Utils, LocalStorage, Storage, Validator,
              Init, UserService, $cookies, AccountService, CountryService, SocialAuthService) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
            $scope.lang = LocaleService.lang;
        });

        $scope.currencyList = Storage.get('currencies');
        $scope.constants = Const;
        $scope.countries = Const['profileAllCountries']
            ? CountryService.get()
            : CountryService.getAllowedCountries();

        $scope.search = {};
        $scope.template = Storage.get('template');
        $scope.isPromo = Storage.get('promocode');
        $scope.promoCodes = Storage.get('promoCodes').reduce(function (accum, promoCode) {
            accum.push({
                promocode: promoCode
            });
            return accum;
        }, []);

        $scope.isAcceptPromotions = Utils.toBoolean(Storage.get('acceptPromotions'));
        //$scope.template = "default";

        $scope.socialAuthService = SocialAuthService;

        $scope.signupForm = {
            email: '',
            password: '',
            confirmPassword: '',
            country: ''
        };
        $scope.showPassword = false;

        if (Storage.get('geo') && Storage.get('geo').country) {
            var country = CountryService.countries.get({code: Storage.get('geo').country, allowRegistration: 1});
            if (country) {
                $scope.signupForm.country = country.code;
                $scope.countryName = country.country;
                $scope.phoneCode = country.phoneCode;
            }
        }

        if ($scope.promoCodes.length) {
            $scope.signupForm.promocode = $scope.promoCodes[0].promocode;
        }

        $scope.validator = Validator.getPattern;

        $scope.navigate = function (state, params) {
            $state.go(state, params);
        };

        $scope.password = {
            checked: false
        };

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false,
            isProcess: false,
            back: 'welcome'
        };

        $scope.accountType = Utils.getURLParameterByName('accountType');

        saveReferral();

        function checkRegistration(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'SignupController',
                    type: Const.error.type.VALIDATION,
                    code: data.code || 'registrationFailed',
                    severity: 'warning',
                    data: {request: $scope.signupForm, response: data}
                });
            }
            return data;
        }

        $scope.countriesModal = function (type, form) {
            $ionicModal.fromTemplateUrl('templates/countries-select.html', {
                scope: $scope,
                hardwareBackButtonClose: false,
                animation: 'slide-in-up'
            }).then(function (modal) {
                $scope.selectType = type;
                $scope.countriesList = type === 'country' ? $scope.countries : $scope.promoCodes;
                $scope.countryModal = modal;
                $scope.countryModal.show();
                $scope.FormController = form;
            });
        };

        $scope.setCountry = function (country) {
            if ($scope.selectType === 'country') {
                $scope.signupForm.country = country.code;
                $scope.countryName = country.country;
                $scope.phoneCode = country.phoneCode;
                $scope.FormController.country.$setDirty();
            } else if ($scope.selectType === 'promocode') {
                $scope.signupForm.promocode = country.promocode;
            }
            $scope.search = {};
            $scope.countryModal && $scope.countryModal.hide();
        };

        $scope.closeCountryModal = function () {
            $scope.countryModal && $scope.countryModal.hide();
            $scope.countriesList = null;
        };


        function login(loginForm) {
            function createLoginRequest() {
                if (loginForm.provider && loginForm.tokenThirdParty) {
                    return LoginService.loginThirdParty(loginForm.login, loginForm.provider, loginForm.tokenThirdParty)
                }

                return LoginService.login(loginForm.login, loginForm.password)
            }

            $scope.loadingMessage = LocaleService.translation.logging_in;
            //console.log('login form', loginForm);

            return createLoginRequest()
                .then(function () {
                    $scope.loadingMessage = LocaleService.translation.starting;
                })
                .then(LoginService.initServices)
                .then(function () {
                    Init.isInitialized = true;
                })
                .then(function () {
                    $ionicLoading.hide();

                    var user = UserService.get();
                    var autoUpdatePersonalDetails = Const['autoUpdatePersonalDetails'] && user.registrationState < Const.userState.questionnaire;
                    if (autoUpdatePersonalDetails) {
                        return $state.go('signupPersonalProfile', {cache: false});
                    }

                    if (Const['showPersonal'] && $scope.accountType !== 'demo') {
                        //check terms
                        if (!user.tnc && Const['tncPopup']) {
                            return $state.go('tnc');
                        }

                        if (user.registrationState <= Const.userState.personal) {
                            return $state.go('root.app.personalDetails');
                        }
                    }

                    if (Const['kycCheck']) {
                        if ($scope.accountType === 'demo') {
                            return AccountService.createAccount(false, user.baseCurrency || user.currency, user.leverage)
                                .then(function (response) {
                                    return AccountService.switchAccount(response.mt4Account.login, !!response.mt4Account.live)
                                })
                                .then(function () {
                                    $ionicLoading.hide();
                                    return $state.go('root.app.assets', {cache: false})
                                })
                        }
                    }

                    return $state.go('root.app.assets', {cache: false});
                })
                .catch(function (error) {
                    console.warn(error);
                    if (error === Const.loginStatus.noActiveAccount) {
                        console.warn(error);
                    }

                    //if we failed in starting any service - do logout sequence
                    return LoginService.logout()
                        .then(function () {
                            $ionicLoading.hide();
                            $scope.modal.isError = true;
                            $scope.modal.textTitle = LocaleService.translation.messages[error.code] || LocaleService.translation.messages.Err600;
                            $scope.modal.textContent = LocaleService.translation.messages.general_error_text;
                            $scope.modal.state = true;
                        })
                        .catch(function (error) {
                            console.warn(error)
                        })
                })
        }

        function signupFormBluePrint(template) {
            switch (template) {
                case 'long':
                    return function (data) {
                        return {
                            firstName: data.firstName,
                            lastName: data.lastName,
                            phone: $scope.phoneCode.toString() + data.phone.toString(),
                            login: data.email,
                            password: data.password,
                            country: data.country,
                            fingerprint: 123,
                            referral: getReferral(),
                            promocode: data.promocode || '',
                            acceptPromotions: Utils.fromBoolean(data.acceptPromotions),
                            terms: Utils.fromBoolean(data.terms),
                            termsNonLeverage: Utils.fromBoolean(data.termsNonLeverage),
                            template: template,
                            language: $scope.lang || 'en'
                        }
                    };
                case 'social':
                    return function (data) {
                        return {
                            firstName: data.firstName,
                            lastName: data.lastName,
                            phone: $scope.phoneCode.toString() + data.phone.toString(),
                            login: data.email,
                            password: data.password,
                            country: data.country,
                            fingerprint: 123,
                            referral: getReferral(),
                            promocode: data.promocode || '',
                            acceptPromotions: Utils.fromBoolean(data.acceptPromotions),
                            terms: Utils.fromBoolean(data.terms),
                            termsNonLeverage: Utils.fromBoolean(data.termsNonLeverage),
                            template: template,
                            language: $scope.lang || 'en',
                            provider: data.provider,
                            tokenThirdParty: data.tokenThirdParty,
                        }
                    };
                default:
                    return function (data) {
                        return {
                            login: data.email,
                            password: data.password,
                            country: data.country,
                            fingerprint: 123,
                            referral: getReferral(),
                            promocode: data.promocode || '',
                            acceptPromotions: Utils.fromBoolean(data.acceptPromotions),
                            terms: Utils.fromBoolean(data.terms),
                            termsNonLeverage: false,
                            template: template,
                            language: $scope.lang || 'en'
                        }
                    };
            }
        }

        function saveReferral() {
            var referralString = Utils.getReferralString();
            if (referralString) {
                $cookies.put('forexAffiliate', referralString, {'path': '/'});
            }
        }

        function getReferral() {
            return decodeURIComponent($cookies.get('forexAffiliate') || '')
                || Utils.getReferralString()
                || '';
        }

        function resetReferral() {
            $cookies.remove('forexAffiliate');
        }

        function registration(form) {

            function createRegistrationRequest(request) {
                if (form.provider && form.tokenThirdParty) {
                    return API.registrationThirdParty(request)
                }

                return API.registration(request)
            }

            var registrationRequest = signupFormBluePrint($scope.template)(form);

            $scope.loadingMessage = LocaleService.translation.account_registration;

            $ionicLoading.show({templateUrl: 'templates/directives/message-spinner.html', scope: $scope});

            return createRegistrationRequest(registrationRequest)
                .then(checkRegistration)
                .then(function (data) {
                    resetReferral();
                    return data;
                })
                .then(Utils.wait(3000))
                .then(function () {
                    return login(registrationRequest);
                })
                .catch(function (error) {
                    //failed registration
                    $ionicLoading.hide();
                    $scope.modal.isError = true;
                    $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.general_error;
                    $scope.modal.textContent = "";
                    $scope.modal.state = true;
                });
        }


        $scope.doRegistration = function (form) {
            Utils.formRevalidate(form, true);

            if (!form.$valid) return;
            var registrationRequest = angular.copy($scope.signupForm);
            return registration(registrationRequest)
        };


        function validateTerms(form) {
            if (form['terms'] && !form['terms'].$viewValue) {
                form['terms'].$setDirty();
                form['terms'].$setTouched();
                return;
            }
            return true
        }


        $scope.signinWithGoogle = function (form) {
            if (!validateTerms(form)) {
                return
            }
            return SocialAuthService.signInWithGoogle()
                .then(function (user) {
                    var registrationRequest = {
                        email: user.email,
                        password: "",
                        provider: "google",
                        tokenThirdParty: user.idToken,
                        firstName: user.firstName,
                        lastName: user.lastName,
                        countryCode: '',
                        phone: '',
                        country: '',
                        promocode: $scope.signupForm.promocode,
                        acceptPromotions: $scope.signupForm.acceptPromotions,
                        terms: $scope.signupForm.terms,
                        termsNonLeverage: $scope.signupForm.termsNonLeverage,
                    };
                    return registration(registrationRequest)
                })
        }

        $scope.signinWithFacebook = function (form) {
            if (!validateTerms(form)) {
                return
            }
            return SocialAuthService.signInWithFacebook()
                .then(function (user) {
                    var registrationRequest = {
                        email: user.email,
                        password: "",
                        provider: "facebook",
                        tokenThirdParty: user.token,
                        firstName: user.firstName,
                        lastName: user.lastName,
                        countryCode: '',
                        phone: '',
                        country: '',
                        promocode: $scope.signupForm.promocode,
                        acceptPromotions: $scope.signupForm.acceptPromotions,
                        terms: $scope.signupForm.terms,
                        termsNonLeverage: $scope.signupForm.termsNonLeverage,
                    };
                    return registration(registrationRequest)
                })
        }


        $scope.$on('$ionicView.afterLeave', function (event) {
            $scope.countryModal && $scope.countryModal.hide() && $scope.countryModal.remove();
        });
    }]);
